export const metadata = {
    title: "The launch of The Futsal Directory 🚀",
    date: "2025-04-22",
    excerpt: "The why behind The Futsal Directory.",
    slug: "the-futsal-directory-launches",
content: `What is the Futsal Directory? That's a great question and seeing as you're reading this I will answer that question for you.

For a long time Futsal has sadly been overlooked, whether it's been reduced to the indoor version of 5-a-side or even more recently as the 'posh' version of football as one viral TikTok comment put it. It's clear that there is a fundamental lack of respect for this sport at a societal and structural level.

Sadly, this has even been evident by FIFA who all too recently used icons of the football world to advertise the 2024 FIFA Futsal World Cup in Uzbekistan.

The Futsal Directory will strictly prioritise the sport of Futsal above others. One of the primary aims of this site will be to provide users with a means of finding a location at which they can play futsal, and foremost we hope to be able to point everyone to a place that they can enjoy the sport that we all love.

We have an ambitious aim of being the most informed platform in the world when it comes to locations at which you can play the beautiful game.`
  };